<template>
  <v-card-text>
    <v-toolbar
      density="compact"
      class="custom-card px-4 py-1 mb-2"
      color="white"
    >
      <v-row density="compact" class>
        <v-col cols="12" sm="6" md="6"> </v-col>
        <v-col cols="12" sm="6" md="6" class="d-flex justify-end">
          <v-btn
            color="primary"
            prepend-icon="mdi-plus"
            class="btn-primary-gradient"
            @click="openAddDialog"
          >
            Add Curator
          </v-btn>
        </v-col>
      </v-row>
    </v-toolbar>

    <v-card class="custom-card border">
      <v-data-table
        :headers="headers"
        :loading="loading"
        :height="vuetifyObject?.height - 205"
        v-model:page="page"
        :items="formattedAdminsList"
        class="elevation-0"
        density="compact"
        hide-default-footer
        :items-per-page="itemsPerPage"
      >
        <template v-slot:[`item.user_name`]="{ item }">
          <div
            class="text-no-wrap font-weight-bold text-grey-darken-3 text-truncate"
          >
            {{ item.user_name }}
          </div>
        </template>

        <template v-slot:[`item.user_role`]="{ item }">
          <v-chip
            size="small"
            variant="tonal"
            :color="
              item.user_role === 'SUPER_CURATOR' || item.user_role == 'OWNER'
                ? 'purple'
                : 'primary'
            "
            class="font-weight-bold"
          >
            {{
              item.user_role === "SUPER_CURATOR"
                ? "Super Curator"
                : item.user_role === "CURATOR"
                ? "Curator"
                : "Owner"
            }}
          </v-chip>
        </template>

        <template v-slot:[`item.country`]="{ item }">
          <v-chip
            size="x-small"
            :variant="item.country === '-' ? 'text' : 'tonal'"
            :color="item.country === '-' ? 'grey' : 'info'"
            class="font-weight-bold"
          >
            {{ item.country }}
          </v-chip>
        </template>

        <template v-slot:[`item.state`]="{ item }">
          <v-chip
            size="x-small"
            :variant="item.state === '-' ? 'text' : 'tonal'"
            :color="item.state === '-' ? 'grey' : 'info'"
            class="font-weight-bold text-truncate"
            style="max-width: 100px"
          >
            {{ item.state }}
          </v-chip>
        </template>

        <template v-slot:[`item.district`]="{ item }">
          <v-chip
            size="x-small"
            :variant="item.district === '-' ? 'text' : 'tonal'"
            :color="item.district === '-' ? 'grey' : 'info'"
            class="font-weight-bold text-truncate"
            style="max-width: 120px"
          >
            {{ item.district }}
          </v-chip>
        </template>

        <template v-slot:[`item.pincode`]="{ item }">
          <v-chip
            size="x-small"
            :variant="item.pincode === '-' ? 'text' : 'tonal'"
            :color="item.pincode === '-' ? 'grey' : 'info'"
            class="font-weight-bold"
          >
            {{ item.pincode }}
          </v-chip>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="item.status === 'Active' ? 'success' : 'error'"
            size="small"
            class="font-weight-bold"
          >
            {{ item.status }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div
            v-if="
              item.user_role !== 'OWNER' &&
              item.user_id !== $store.getters.get_current_user_details.user_id
            "
            class="d-flex justify-center"
          >
            <v-menu location="bottom end">
              <template v-slot:activator="{ props }">
                <v-btn
                  icon="mdi-dots-vertical"
                  size="small"
                  variant="text"
                  color="grey-darken-2"
                  v-bind="props"
                ></v-btn>
              </template>

              <v-list density="compact" elevation="3" class="rounded-lg border">
                <v-list-item
                  :disabled="
                    $store?.getters?.get_current_user_details?.user_role ===
                    'CURATOR'
                  "
                  @click="editAdmin(item)"
                  title="Edit"
                >
                  <template v-slot:prepend>
                    <v-icon size="small" color="success">mdi-pencil</v-icon>
                  </template>
                </v-list-item>

                <v-list-item
                  :disabled="
                    $store?.getters?.get_current_user_details?.user_role ===
                    'CURATOR'
                  "
                  @click="deleteAdmin(item)"
                  title="Delete"
                >
                  <template v-slot:prepend>
                    <v-icon size="small" color="error">mdi-delete</v-icon>
                  </template>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>

      <v-divider></v-divider>
      <v-pagination
        density="compact"
        :length="pageCount"
        v-model="page"
        class="py-1"
      ></v-pagination>
    </v-card>

    <admin-dialog
      v-model:dialog="adminDialog"
      :dialog-type="currentDialogType"
      :selected-admin="selectedAdmin"
      :status-action="currentStatusAction"
      :internalPincodes="internalPincodes"
      @clicked="adminDialogEmit"
    />
    <DeleteCuratorDialog
      v-model:deleteCuratorDialog="deleteCuratorDialog"
      :curator="selectedAdmin"
      @update="deleteAdminEmit"
    />
  </v-card-text>
</template>

<script>
import AdminCard from "@/components/Admins/Cards/AdminCard.vue";
import AdminDialog from "@/components/Admins/Dialogs/AdminDialog.vue";
import { GetAllAdmins } from "@/mixins/Admins/GetAllAdmins.js";
import DeleteCuratorDialog from "@/components/Admins/Dialogs/DeleteCuratorDialog.vue";

export default {
  name: "AdminsPage",
  components: {
    AdminCard,
    AdminDialog,
    DeleteCuratorDialog,
  },
  props: {
    vuetifyObject: {
      type: Object,
      required: true,
    },
    internalPincodes: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [GetAllAdmins],
  data() {
    return {
      viewMode: "grid",
      searchQuery: "",
      selectedRole: "ADMIN",
      roleOptions: [
        { title: "Super Admin", value: "SUPERADMIN" },
        { title: "Admin", value: "ADMIN" },
      ],
      // Dialog properties
      page: 1,
      itemsPerPage: 100,
      loading: false,
      adminDialog: false,
      deleteCuratorDialog: false,
      currentDialogType: "create",
      selectedAdmin: null,
      currentStatusAction: "activate",
      successMessage: "",
      showSuccess: false,
      // Updated Headers
      headers: [
        { title: "Name", key: "user_name", width: "15%" }, // Expanded
        { title: "Email", key: "user_email_id", width: "18%" },
        { title: "Role", key: "user_role", width: "10%" },
        { title: "Country", key: "country", width: "5%" }, // Compacted
        { title: "State", key: "state", width: "10%" }, // Compacted
        { title: "District", key: "district", width: "11%" }, // Compacted
        { title: "Pincode", key: "pincode", width: "3%" }, // Compacted
        { title: "Actions", key: "actions", sortable: false, width: "2%" },
      ],
      GetAllAdminsList: [],
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.formattedAdminsList.length / this.itemsPerPage);
    },
    // High-performance computed property to map geographic data to rows
    formattedAdminsList() {
      return this.GetAllAdminsList.map((admin) => {
        const geoDetails = this.getGeoDetails(
          admin.user_target_type,
          admin.user_target_value,
        );
        return {
          ...admin,
          country: geoDetails.country,
          state: geoDetails.state,
          district: geoDetails.district,
          pincode: geoDetails.pincode,
        };
      });
    },
  },
  async mounted() {
    await this.GetAllAdminsMethod();
  },
  methods: {
    // Reverse-Lookup Logic
    getGeoDetails(type = "GLOBAL", val = "GLOBAL") {
      // 1. Initialize everything to a dash by default
      let country = "-";
      let state = "-";
      let district = "-";
      let pincode = "-";

      // 2. Cascade down based on the specific target type
      if (type === "GLOBAL") {
        country = "GLOBAL"; // Or change to "ALL" depending on your preference
      } else if (type === "COUNTRY") {
        country = val;
      } else if (type === "STATE") {
        country = "INDIA";
        state = val;
      } else if (type === "DISTRICT") {
        country = "INDIA";
        district = val;
        const loc = this.internalPincodes.find((p) => p.District === val);
        if (loc) state = loc.StateName;
      } else if (type === "PINCODE") {
        country = "INDIA";
        pincode = val;
        const loc = this.internalPincodes.find((p) => p.Pincode === val);
        if (loc) {
          state = loc.StateName;
          district = loc.District;
        }
      }

      return { country, state, district, pincode };
    },

    getInitials(name) {
      return name
        .split(" ")
        .map((n) => n.charAt(0))
        .join("")
        .toUpperCase();
    },
    getAvatarColor(name) {
      const colors = ["#667eea", "#764ba2", "#f093fb", "#f5576c", "#4facfe"];
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },
    // Dialog Methods
    openAddDialog() {
      this.currentDialogType = "create";
      this.selectedAdmin = null;
      this.adminDialog = true;
    },
    editAdmin(admin) {
      this.currentDialogType = "edit";
      this.selectedAdmin = admin;
      this.adminDialog = true;
    },
    deleteAdmin(admin) {
      this.currentDialogType = "delete";
      this.selectedAdmin = admin;
      this.deleteCuratorDialog = true;
    },
    openDeleteDialog(admin) {
      this.currentDialogType = "delete";
      this.selectedAdmin = admin;
      this.adminDialog = true;
    },
    openStatusDialog(admin) {
      this.currentDialogType = "status";
      this.selectedAdmin = admin;
      this.currentStatusAction =
        admin.status === "Active" ? "deactivate" : "activate";
      this.adminDialog = true;
    },
    async adminDialogEmit(Toggle) {
      this.adminDialog = false;
      if (Toggle === 2) {
        await this.GetAllAdminsMethod();
      }
    },
    async deleteAdminEmit(Toggle) {
      this.deleteCuratorDialog = false;
      if (Toggle === 2) {
        await this.GetAllAdminsMethod();
      }
    },
  },
};
</script>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
:deep(.v-table__wrapper::-webkit-scrollbar) {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
:deep(.v-table__wrapper) {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* Optional: If the table body itself is triggering the scrollbar */
:deep(.v-data-table__wrapper::-webkit-scrollbar) {
  display: none;
}
:deep(.v-data-table__wrapper) {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.admins-container {
  background-color: #f5f7fa;
  border-radius: 12px;
}

.text-2c3e50 {
  color: #2c3e50;
}

.text-sm {
  font-size: 0.9rem;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.text-semibold {
  font-weight: 600;
}

.text-muted {
  color: #888888;
}

.btn-primary-gradient {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}
</style>
